import cloneDeep from 'lodash/cloneDeep'

// todo 这里的递归也存在问题，数组地下项没有考虑
// 遍历model节点
export function walkModelTree(tree, fn) {
  const props = tree.props ? Object.keys(tree.props) : []
  props.forEach(prop => {
    walkModelTree(tree.props[prop], fn, tree)
    fn && fn(prop, tree.props[prop])
  })
}

// 规格化
export function normalizeModels (models) {
  const initModels = { props: cloneDeep(models) }
  walkModelTree(initModels, (prop, model) => {
    model.name = prop // 把属性名称写入到对象中name字段，方便后面使用
    if (model.type === 'array' || model.type === 'typeArray' || model.type === 'richMap') { // 数组默认值为空数组，防止后面数组异常
      if (!model.value) model.value = []
      if (!model.defaultValue) model.defaultValue = []
    }
    if (model.type === 'array' || model.type === 'typeArray' || model.type === 'richMap' || model.type === 'object') {
      model.isUsed = false
      model.isExpand = false

      // 强制展开
      if (model.isExpandForce === true) {
        model.isExpand = true
      }
    }

    // 一个对象，太多属性，配置一下子显示太多，容易让人眼花缭乱，通过isMore来控制按钮来显示更多内容
    if (model.type === 'object') {
      model.isMore = false
    }

    if (model.simpleArray) { // 简单数组，value统一转换成带props.value属性对象处理
      model.value = model.value.map(item => {
        const newValue = cloneDeep(model.props)
        newValue.value.value = item
        return {
          props: newValue
        }
      })
      model.defaultValue = model.defaultValue.map(item => {
        const newValue = cloneDeep(model.props)
        newValue.value.value = item
        return {
          props: newValue
        }
      })
    }
  })
  return initModels.props
}
